// TablaObras.jsx
import React, { useState, useEffect, useMemo, useContext } from 'react';

import { useLocalStorage } from "../hooks/useLocalStorage";
import {useEstadoApp} from "../context/EstadoAppContext";
import { AuthContext } from '../context/authContext';
import { useNavigate } from 'react-router-dom';

// Componente simple de barra de progreso
const ProgressBar = ({ percentage }) => {
    // Clases dinámicas de Tailwind
    const color = percentage > 100 ? 'bg-red-600' : percentage === 100 ? 'bg-green-600' : percentage > 0 ? 'bg-indigo-600' : 'bg-gray-300';
    
    return (
        <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5">
            <div 
                className={`h-2.5 rounded-full ${color}`} 
                style={{ width: `${percentage}%` }}
            ></div>
        </div>
    );
};

const TablaObras = ({ data, arrayEditando }) => { //handleIsEditing
    console.log("TablaObras", data); 
    // Clases CSS simples para los encabezados (puedes reemplazarlas por tu sistema de estilos)
    //const thClasses = { padding: '10px', borderBottom: '2px solid #ccc', textAlign: 'left' };
    //const tdClasses = { padding: '10px', borderBottom: '1px solid #eee' };
	const { setItem, removeItem } = useLocalStorage();
	const { user } = useContext(AuthContext)

	const { estadoAppX, cambiarEstadoApp } = useEstadoApp(); // Usamos nuestro custom hook

	const navigate = useNavigate();

    const thClasses = `px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider`;
    const tdClasses = `px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-gray-200`;

	//crear onRowDoubleClick
	const handleRowDoubleClick = (idPartidoObra) => {
		console.log("CHEQUEAR handleRowDoubleClick", idPartidoObra)
		console.log('Navegando a InicioPage con id_partido_obra:', idPartidoObra);
		// Determinar si OTRO usuario está editando este registro.
		// Si es así, entramos en modo SOLO LECTURA (isEditingPagos="true" en InicioPage).
		// Si nadie más lo edita, entramos en modo edición normal (isEditingPagos="false").
		const otroEdita = isEditingByOtherUser(idPartidoObra);
		setItem("isEditingPagos", otroEdita ? true : false);

		setItem("idPartidoObra", idPartidoObra)

		cambiarEstadoApp("edit_desde_pagos", { //ediT
			obra: idPartidoObra,
			origen: 'tramitaciones' 
		});

		navigate(`/inicio?id_partido_obra=${encodeURIComponent(idPartidoObra)}`);//, { state: { id_partido_obra: idPartidoObra } }
		//handleIsEditing(isEditingPagos)
	}

	// Función para verificar si una fila está siendo editada
    const isRowBeingEdited = (obraId) => {
        // Si el array está vacío, retornar falso inmediatamente
        /*if (!arrayEditando || arrayEditando.length === 0) {
            return false;
        }*/
		console.log("GATO arrayEditando", arrayEditando)

        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        // Verificar si la obra está siendo editada por otro usuario
        const isEditing = safeArray.some(objeto => {
            // Verificar que el objeto tenga las propiedades necesarias
            if (!objeto || !objeto.id_edit || !objeto.user_edit || !objeto.status) {
                return false;
            }
            // Limpiamos las comillas dobles de user_edit para la comparación
            const userEditClean = objeto.user_edit.replace(/"/g, '');
            return objeto.id_edit === obraId && objeto.status === 'editando'; //&& userEditClean !== user 
        });
        
        //console.log("IS EDITING", isEditing)
        return isEditing;
        //return arrayEditando[obraId]?.length > 0;
    };

	//funcion para verificar si ademas es 'solo_lectura'
    const isRowBeingReadOnly = (obraId) => {
        // Si el array está vacío, retornar falso inmediatamente
        /*if (!arrayEditando || arrayEditando.length === 0) {
            return false;
        }*/

         // Asegurarse de que arrayEditando sea un array
        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        // Verificar si la obra está siendo editada por otro usuario
        const isReadOnly = safeArray.some(objeto => {
            // Verificar que el objeto tenga las propiedades necesarias
            if (!objeto || !objeto.id_edit || !objeto.user_edit || !objeto.status) {
                return false;
            }
            // Limpiamos las comillas dobles de user_edit para la comparación
            const userEditClean = objeto.user_edit.replace(/"/g, ''); //HACE falta??
            return objeto.id_edit === obraId && userEditClean !== user && objeto.status === 'solo_lectura';
        });
        
        //console.log("IS EDITING", isEditing)
        return isReadOnly;
        //return arrayEditando[obraId]?.length > 0;
    };

	// Verifica si OTRO usuario (distinto al actual) está editando la obra (status 'editando')
    const isEditingByOtherUser = (obraId) => {
        const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];
        return safeArray.some(objeto => {
            if (!objeto || !objeto.id_edit || !objeto.user_edit || !objeto.status) {
                return false;
            }
            const userEditClean = objeto.user_edit.replace(/"/g, '');
            return objeto.id_edit === obraId && objeto.status === 'editando' && userEditClean !== user;
        });
    };

	const getEditingTooltip = (obraId) => {
        try {
            const safeArray = Array.isArray(arrayEditando) ? arrayEditando : [];

            //Verificar si hay id_edit con status 'editando' y 'solo_lectura' y devolver el user_edit
            const editando = safeArray.find(item => item && item.id_edit === obraId && item.status === 'editando');
            const soloLectura = safeArray.find(item => item && item.id_edit === obraId && item.status === 'solo_lectura');

            if (editando && soloLectura) {
                return `Editando usuario: ${editando.user_edit} - Solo lectura: ${soloLectura.user_edit}`;
            } else if (soloLectura) {
                return `Solo lectura: ${soloLectura.user_edit}`;
            } else if (editando){
                return `Editando usuario: ${editando.user_edit}`;
            }
           
        } catch (error) {
            console.error('Error en getEditingTooltip:', error);
            return '';
        }
    };

    if (!data || data.length === 0) {
        return <p>No hay obras para mostrar con los filtros aplicados.</p>;
    }
	

    return (
        <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead className="bg-gray-50 dark:bg-gray-800">
                    <tr>
                        <th className={thClasses}>ID</th>
                        <th className={thClasses}>Nombre de Obra</th>
                        <th className={thClasses}>Nro. Exp. Proyecto</th>
                        <th className={thClasses}>Nro. Expediente</th>
                        <th className={thClasses}>Objeto</th>
                        <th className={thClasses}>Organismo Solicitante</th>
                        <th className={thClasses}>Monto Conveniado / Adenda</th>
                        <th className={thClasses}>Monto Total Pagado</th>
                        <th className={thClasses}>Avance de Pagos</th>
                        <th className={thClasses}>Último Pago</th>
                        <th className={thClasses}>Observaciones</th>
                    </tr>
                </thead>
				<tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
					{data.map((item, index) => {
						const isEditing = isRowBeingEdited(item.id_partido_obra);
						console.log("IS EDITING tabla pagos", index, isEditing)
						//si tiene status solo_lectura crear una constante isReadOnly
                        const isReadOnly = isRowBeingReadOnly(item.id_partido_obra);

						const editingTooltip = item.organismoSolicitante;
						const editingTooltip_EDITANDO = getEditingTooltip(item.id_partido_obra);
						return (
							<tr
								key={item.id || index}
								//className="hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors duration-150"
								className={`hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer transition-colors duration-150 ${(isEditing === true && isReadOnly === true)
									? 'hover:bg-red-200 bg-red-200 dark:hover:bg-red-200/20 dark:bg-red-200/20 dark:border-l-4 dark:border-l-red-200'
									: ''
									} ${(isReadOnly === true && isEditing === false)
										? 'hover:bg-yellow-200 bg-yellow-200 dark:hover:bg-yellow-200/20 dark:bg-yellow-200/20 dark:border-l-4 dark:border-l-yellow-200'
										: ''
									} ${(isEditing === true && isReadOnly === false)
										? 'hover:bg-red-200 bg-red-200 dark:hover:bg-red-200/20 dark:bg-red-200/20 dark:border-l-4 dark:border-l-red-200'
										: ''
									}`}
								title={editingTooltip_EDITANDO}
								onDoubleClick={() => handleRowDoubleClick && handleRowDoubleClick(item.id_partido_obra)}>
                                <td className={tdClasses}>{item.id_partido_obra || 'N/A'}</td>
								<td className={tdClasses}>{item.nombreObra}</td>
								<td className={tdClasses}>{item.nroExpProyecto}</td>
								<td className={tdClasses}>{item.nroExpediente}</td>
								<td className={tdClasses}>**{item.objeto}**</td>
								{/* ⭐️ CELDA DEL ORGANISMO SOLICITANTE MODIFICADA ⭐️ */}
								<td className="px-6 py-4 whitespace-nowrap">
									<div
										className="max-w-xs truncate"
										title={editingTooltip}
									>
										{item.organismoSolicitante}
									</div>
								</td>
								{/* ⭐️ FIN DE LA CELDA MODIFICADA ⭐️ */}
								<td className={tdClasses}>{item.montoConvenioAdenda}</td>
								<td className={tdClasses}>{item.montoTotalPagado}</td>
								{/* ⭐️ CELDA DE AVANCE MODIFICADA ⭐️ */}
								<td className="px-6 py-4 whitespace-nowrap">
									<div className="flex items-center">
										<div className="w-full mr-4">
											{/* Etapa Actual */}
											<div className="text-sm font-medium text-gray-900 dark:text-white">
												{item.etapaActual}
											</div>
											<div className="mt-1">
												<ProgressBar percentage={item.avancePagos} />
											</div>
										</div>
										{/* Porcentaje */}
										<span className="text-sm font-medium text-gray-500 dark:text-gray-300 w-10 text-right">
											{item.avancePagos.toFixed(0)}%
										</span>
									</div>
								</td>
								{/* ⭐️ FIN CELDA DE AVANCE MODIFICADA ⭐️ */}
								<td className={tdClasses}>{item.ultimoPago}</td>
								<td className={tdClasses}>{item.observaciones}</td>
							</tr>
						)
					})}
				</tbody>
            </table>
        </div>
    );
};

export default TablaObras;